const {
  handleRemoveProductImage,
  handleColorScroll,
  renderPrice,
  handleDiscountSelection,
  multipleProducts,
  renderDiscount,
  handleProductImage
} = await import(`./configurator-utils.js?v=${Date.now()}`);
const { pricing } = await import(`./pricing.js?v=${Date.now()}`);
class ConfiguratorExtra extends HTMLElement {
  constructor() {
    super();
    let checkboxes = this.querySelectorAll(".checkbox");
    let localCheckbox = this.querySelector(".checkbox");
    let nextButton = this.querySelector(".button-holder__button");
    let buttonRow = document.querySelector(".button-row__fade");
    let extrasBaseProduct = JSON.parse(this.querySelector(".js-extra-base").innerHTML);
    let productData = JSON.parse(this.querySelector(".js-product-data").innerHTML);
    let a2cButton = document.querySelector(".js-a2c");
    let colorGrids = this.querySelectorAll(".color-grid");
    this.querySelector(".js-continue");
    this.querySelector(".js-false");
    this.querySelector(".configurator-extra-overlay");
    let extraTitle = document.querySelector(".extra__title");
    let pricingElement = this.querySelector(".js-pricing");
    let previousButton = this.querySelector(".button-holder__button--previous");
    let currentLayer = nextButton.dataset.current;
    let nextLayer = nextButton.dataset.next;
    let nextStep = document.querySelector(`.layer-${nextLayer}`);
    let currentStep = document.querySelector(`.layer-${currentLayer}`);
    let checkmark = document.querySelector(`.layer-label-${nextLayer - 1} .icon-checkmark`);
    let currentOption = document.querySelector(".button-row__button input[checked]");
    let discountbase = document.querySelector("configurator-overview").dataset.baseDiscount;
    let discountextra = document.querySelector("configurator-overview").dataset.extraDiscount;
    currentOption.dataset.layer <= 3 ? discountbase : discountextra;
    let select = this.querySelector("select");
    let param = select.getAttribute("data-select");
    console.log("extra");
    const setUrlParams = (selectElement, variant, product, productId) => {
      let id = product ? product.id : productId;
      let param2 = selectElement.getAttribute("data-select");
      let url = new URL(window.location.href);
      url.searchParams.set(param2, `${id}-${variant.id}`);
      window.history.replaceState({}, "", url);
    };
    const handleNextLayer = () => {
      let newScrollPosition = currentStep.nextElementSibling.offsetWidth + buttonRow.scrollLeft;
      let overviewStep = document.querySelector(".layer-4");
      if (nextStep) {
        nextStep.checked = true;
        nextStep.classList.add("active");
        currentStep.nextElementSibling.classList.add("handled");
        nextStep.parentElement.classList.remove("button-row__button--no-events");
        buttonRow.scroll({
          top: 0,
          left: newScrollPosition,
          behavior: "smooth"
        });
        if (nextStep.closest(".button-row__button.hidden") != null) {
          document.querySelector(".layer-5").checked = true;
          document.querySelector(".layer-5").classList.add("active");
          document.querySelector(`.layer-label-${5} .icon-checkmark`).classList.toggle("icon-checkmark--active");
        }
      } else {
        extraTitle.style.display = "block";
        overviewStep.checked = true;
        overviewStep.classList.toggle("active");
        let selectedItems = JSON.parse(sessionStorage.getItem("configuratorConfig"));
        let filteredItems = selectedItems ? selectedItems.filter((selectedItem) => selectedItem !== null) : [];
        let selected_items = [];
        filteredItems.forEach((val) => {
          console.log(Object.entries(val)[0][1]);
          if (Object.entries(val)[0][1].extraProduct === true) {
            for (let i in val) {
              let v = val[i];
              if (v && v.product_title && v.option1 && v.option2) {
                selected_items.push({
                  title: v.product_title,
                  select_colour: v.full_option1,
                  select_size: v.full_option2
                });
              }
            }
          } else {
            selected_items.push({
              title: val.product_title,
              select_colour: val.full_option1,
              select_size: val.full_option2
            });
          }
        });
        window.dataLayer = window.dataLayer || [];
        let alreadyPushed = window.dataLayer.some(
          (entry) => {
            var _a;
            return entry.event === "configuratorItemsSelected" && JSON.stringify((_a = entry.ecommerce) == null ? void 0 : _a.items) === JSON.stringify(selected_items);
          }
        );
        if (!alreadyPushed) {
          window.dataLayer.push({
            event: "configuratorItemsSelected",
            ecommerce: {
              items: selected_items
            }
          });
        }
      }
      let buttons = document.querySelectorAll(".button-row__button.hidden");
      buttons.forEach((button) => {
        if (button.querySelector(".icon-checkmark--active") != null) {
          document.querySelector(".layer-5").checked = true;
          document.querySelector(".layer-5").classList.add("active");
          document.querySelector(`.layer-label-${5} .icon-checkmark`).classList.toggle("icon-checkmark--active");
        }
      });
      console.log(overviewStep);
      setTimeout(() => {
        document.querySelector(".layer-label-4").click();
        document.querySelector(".configurator-variant").classList.add("hidden");
        document.querySelector('.configurator-variant[data-layer="4"]').classList.remove("hidden");
      }, 1e3);
    };
    const handleBaseProductVariant = (config) => {
      let buildTitle = "";
      if (config[4] && config[4][1]) {
        buildTitle += `BP${config[4][1].option2.toLowerCase()}`;
      }
      if (config[4] && config[4][2]) {
        buildTitle += `BK${config[4][2].option2.toLowerCase()}`;
      }
      if (config[4] && config[4][3]) {
        buildTitle += `K${config[4][3].option2.toLowerCase()}`;
      }
      let variant = extrasBaseProduct.variants.find((variant2) => {
        return variant2.title === buildTitle;
      });
      a2cButton.dataset.extra = variant ? variant.id : null;
    };
    const handleVariantChange = (value, selector, item, remove, select2 = null) => {
      if (value.includes("bedMATE") || value.includes("bigDOT")) {
        let valueMinusPrice = value.split(" - ")[1];
        let productTitle = value.split(" - ")[0];
        let _productData = JSON.parse(this.querySelector(`.js-product-${selector}`).innerHTML);
        let layer = this.querySelector(`.product-${selector}`) ? this.querySelector(`.product-${selector}`).dataset.layer : null;
        let selectedItem = _productData.map((product) => {
          return product.variants.find((variant2) => {
            return variant2.product_title.includes(productTitle) && variant2.title.includes(valueMinusPrice);
          });
        });
        let variant;
        selectedItem.forEach((item2) => {
          if (item2 !== void 0) {
            variant = item2;
          }
        });
        setUrlParams(select2, variant, _productData.filter((item2) => {
          return item2.variants.includes(variant);
        })[0], variant.product_id);
        let currentConfig = sessionStorage.getItem("configuratorConfig") ? JSON.parse(sessionStorage.getItem("configuratorConfig")) : [];
        if (currentConfig["4"]) {
          currentConfig["4"][item] = variant;
        } else {
          currentConfig["4"] = {};
          currentConfig["4"][item] = variant;
        }
        sessionStorage.setItem("configuratorConfig", JSON.stringify(currentConfig));
        handleBaseProductVariant(currentConfig);
        renderPrice(handleDiscountSelection(currentConfig));
        let option = select2.querySelector(`option[data-id="${variant.id.toString()}"]`);
        var option_html = option ? option.textContent : null;
        console.log("option_html ", option_html, " variant ", variant, multipleProducts(variant, option_html), select2);
        if (variant && pricingElement) {
          let isMultiple = option_html ? option_html.indexOf(window.pieces_text) > -1 : multipleProducts(variant, option_html ? option_html.trim() : null);
          if (select2 != null) {
            if (select2.dataset.select == "extra-bedmate" || select2.dataset.select == "extra-bigdot") {
              isMultiple = false;
            }
          }
          let discountedPrice = pricing(
            renderDiscount(
              variant.price,
              Number(discountextra),
              isMultiple
            )
          );
          let originalPrice = isMultiple ? pricing(variant.price * 2) : pricing(variant.price);
          pricingElement.innerHTML = `${discountedPrice}<span class="percentage">(20%)</span><s>${originalPrice}</s> `;
        }
        if (currentConfig && currentConfig[4]) {
          console.log("ssssss");
          let extraProducts = currentConfig[4];
          let totalPrice = 0;
          Object.values(extraProducts).forEach((item2) => {
            if (item2 && item2.product_id) {
              let price = item2.price;
              totalPrice += price;
              console.log("totalPrice ", totalPrice);
            }
          });
          let discounted = totalPrice - totalPrice * 0.2;
          let formattedDiscounted = pricing(discounted);
          let formattedOriginal = pricing(totalPrice);
          document.querySelectorAll(".js_price_extra")[document.querySelectorAll(".js_price_extra").length - 1].innerHTML = formattedDiscounted + "(20% off) <s>" + formattedOriginal + "</s>";
        }
        if (layer && remove === false) {
          handleProductImage(variant.image, layer, variant.image_url);
        }
      } else {
        let _valueMinusPrice = value.split(" - ")[0];
        let _productData2 = JSON.parse(this.querySelector(`.js-product-${selector}`).innerHTML);
        let _layer = this.querySelector(`.product-${selector}`) ? this.querySelector(`.product-${selector}`).dataset.layer : null;
        let _variant = _productData2.variants !== void 0 ? _productData2.variants.find((variant) => {
          return variant.title.includes(_valueMinusPrice);
        }) : _productData2.find((variant) => {
          return variant.title.includes(_valueMinusPrice);
        });
        let _currentConfig = sessionStorage.getItem("configuratorConfig") ? JSON.parse(sessionStorage.getItem("configuratorConfig")) : [];
        if (_currentConfig["4"]) {
          _currentConfig["4"][item] = _variant;
        } else {
          _currentConfig["4"] = {};
          _currentConfig["4"][item] = _variant;
        }
        sessionStorage.setItem("configuratorConfig", JSON.stringify(_currentConfig));
        handleBaseProductVariant(_currentConfig);
        renderPrice(handleDiscountSelection(_currentConfig));
        let option = select2.querySelector(`option[data-id="${_variant.id.toString()}"]`);
        var option_html = option ? option.textContent : null;
        console.log("option_html ", option_html, " _variant ", _variant, multipleProducts(_variant, option_html), select2, " ss");
        if (_variant && pricingElement) {
          let isMultiple = option_html ? option_html.indexOf(window.pieces_text) > -1 : multipleProducts(_variant, option_html ? option_html.trim() : null);
          if (select2 != null) {
            if (select2.dataset.select == "extra-bedmate" || select2.dataset.select == "extra-bigdot") {
              isMultiple = false;
            }
          }
          let originalPrice = isMultiple ? pricing(_variant.price * 2) : pricing(_variant.price);
          let discountedPrice = pricing(
            renderDiscount(_variant.price, 20, isMultiple)
          );
          pricingElement.innerHTML = `${discountedPrice}<span class="percentage">(20%)</span> <s>${originalPrice}</s>`;
        }
        if (_layer && remove === false) {
          handleProductImage((_variant === null || _variant === void 0 ? void 0 : _variant.image) !== void 0 ? _variant.image : _variant.images, _layer, _variant.image_url);
        }
      }
      let variantSelector = this.querySelector(`.variant-selector__select--${selector}`);
      console.log(variantSelector, " variantSelector ", variantSelector.value);
      let isLast = variantSelector.closest("configurator-extra") === document.querySelectorAll("configurator-extra")[document.querySelectorAll("configurator-extra").length - 1];
      if (variantSelector.querySelector(`option[value="${variantSelector.value}"]`).hasAttribute("disabled") == true) {
        variantSelector.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.add("disabled");
        if (isLast) {
          variantSelector.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.add("for_the_last");
        }
      } else {
        variantSelector.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.remove("disabled");
        if (isLast) {
          variantSelector.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.remove("for_the_last");
        }
      }
    };
    const handlePillowColor = (product, value, selector, item, select2 = null) => {
      let variant = product.variants.find((variant2) => {
        return variant2.title.includes(value);
      });
      if (variant == void 0 || variant == null) {
        variant = product.variants.find((variant2) => {
          return variant2.title.includes(value.split("-")[1].trim());
        });
      }
      let currentConfig = sessionStorage.getItem("configuratorConfig") ? JSON.parse(sessionStorage.getItem("configuratorConfig")) : [];
      if (currentConfig["4"]) {
        currentConfig["4"][item] = variant;
      } else {
        currentConfig["4"] = {};
        currentConfig["4"][item] = variant;
      }
      var option_html = null;
      var option = null;
      if (select2 != null) {
        console.log("select ", select2, " sssssss sss");
        option = select2.querySelector(`option[data-id="${variant.id.toString()}"]`);
        option_html = option ? option.textContent : null;
      }
      console.log("option_html ", option_html, " variant ", variant, option_html ? option_html.indexOf(window.pieces_text) > -1 : multipleProducts(variant, option_html ? option_html.trim() : null), select2, option, " ss");
      let isMultiple = option_html ? option_html.indexOf(window.pieces_text) > -1 : multipleProducts(variant, option_html ? option_html.trim() : null);
      if (select2 != null) {
        if (select2.dataset.select == "extra-bedmate" || select2.dataset.select == "extra-bigdot") {
          isMultiple = false;
        }
      }
      let originalPrice = isMultiple ? pricing(variant.price * 2) : pricing(variant.price);
      let discountedPrice = pricing(
        renderDiscount(
          variant.price,
          Number(discountextra),
          isMultiple
        )
      );
      pricingElement.innerHTML = `${discountedPrice} <span class="percentage">(${discountextra}%)</span><s>${originalPrice}</s> `;
      sessionStorage.setItem("configuratorConfig", JSON.stringify(currentConfig));
      handleBaseProductVariant(currentConfig);
    };
    const handleProductSelect = (product, select2, checkbox, elementSelector) => {
      console.log(elementSelector, " elementSelector", select2);
      let variants = product.variants;
      let allowedOptions = ["50X140", "50X160", "50X180", "60X70", "50X10", "65X65", "50X75", "40X80", "50X70", "60X63", "80X80"];
      let layer = this.querySelector(`.product-${elementSelector}`) ? this.querySelector(`.product-${elementSelector}`).dataset.layer : null;
      let bedMateSize = sessionStorage.getItem("bedMateSize") ? sessionStorage.getItem("bedMateSize") : null;
      let prefSize = sessionStorage.getItem("studiosuite_pref_size") ? JSON.parse(sessionStorage.getItem("studiosuite_pref_size")) : null;
      let items = 0;
      let options = [];
      if (select2.dataset.select == "extra-bedmate" || select2.dataset.select == "extra-bigdot") {
        let jsonScript = select2.closest("configurator-extra").querySelector(".js-product-data");
        if (jsonScript) {
          let data = JSON.parse(jsonScript.textContent);
          let allVariants = data.flatMap((product2) => product2.variants);
          options = allVariants.map((variant) => {
            items++;
            return `<option data-size="${variant.option2.split("X").pop()}" ${variant.available ? "" : "disabled"} value="${variant.product_title} - ${variant.option2}">${variant.product_title} - ${variant.option2}</option>`;
          });
        }
      } else {
        options = variants.map((variant) => {
          if (allowedOptions.includes(variant.option2.toUpperCase())) {
            if (variant.available) ;
            items++;
            return `<option
          value="${variant.option2}"
          data-old-price="${pricing(variant.price)}"
          data-id="${variant.id}"
          ${!variant.available ? "disabled" : ""}
          ${variant.option2.includes("80X80") && variant.inventory_quantity <= 1 ? "disabled" : ""}
          ${variant.option2.includes("40X80") && variant.inventory_quantity <= 1 ? "disabled" : ""}
          ${variant.option2.includes("50X70") && variant.inventory_quantity <= 1 ? "disabled" : ""}
          ${variant.option2.includes("60X63") && variant.inventory_quantity <= 1 ? "disabled" : ""}
          ${variant.option2.includes("90X200X30") && variant.inventory_quantity <= 1 ? "disabled" : ""}
          ${variant.option2.includes("50X80") && variant.inventory_quantity <= 1 ? "disabled" : ""}
          ${variant.option2 == "50X160test" && product.product_type == "bedMATE case" && variant.inventory_quantity <= 1 ? "disabled" : ""}
          ${variant.option2.includes("140X200") && variant.inventory_quantity <= 1 ? "disabled" : ""}
          ${variant.option2.includes("140X220") && variant.inventory_quantity <= 1 ? "disabled" : ""}
          ${variant.option2.includes("60X70") && variant.inventory_quantity <= 1 ? "disabled" : ""}
          ${variant.option2.includes("60X65") && variant.inventory_quantity <= 1 ? "disabled" : ""}
          ${variant.option2.includes("50X75") && variant.inventory_quantity <= 1 ? "disabled" : ""}
          ${variant.option2.includes("135") && variant.inventory_quantity <= 1 ? "disabled" : ""}
          ${variant.option2.includes("155") && variant.inventory_quantity <= 1 ? "disabled" : ""}
          ${variant.option2.includes(prefSize) ? "selected" : ""}
          ${variant.option2.includes(bedMateSize) ? "selected" : ""}>
           ${variant.option2.includes("80X80") || variant.option2.includes("40X80") || variant.option2.includes("50X70") || variant.option2.includes("60X63") || variant.option2.includes("90X200X30") || variant.option2.includes("50X80") || variant.option2 == "50X160test" && product.product_type == "bedMATE case" || variant.option2.includes("140X200") || variant.option2.includes("140X220") || variant.option2.includes("60X70") || variant.option2.includes("65X65") || variant.option2.includes("50X75") || variant.option2.includes("135") || variant.option2.includes("155") ? variant.option2 + " " + window.pieces_text : variant.option2}
          </option>`;
          }
        });
      }
      if (items === 1) {
        select2.style.backgroundImage = "none";
      }
      let selectedVariant = variants.find((variant) => {
        return variant.option2.includes(prefSize);
      }) !== void 0 ? variants.find((variant) => {
        return variant.option2.includes(prefSize);
      }) : variants.find((variant) => {
        return variant.option2.includes(bedMateSize);
      });
      let BaseOrSelectedVariant = selectedVariant !== void 0 ? selectedVariant : variants[0];
      console.log(BaseOrSelectedVariant);
      setUrlParams(select2, BaseOrSelectedVariant, product);
      if (BaseOrSelectedVariant && pricingElement) {
        let option = select2.querySelector(`option[data-id="${BaseOrSelectedVariant.id.toString()}"]`);
        var option_html = option ? option.textContent : null;
        console.log("option_html ", option_html, option, " BaseOrSelectedVariant ", BaseOrSelectedVariant, multipleProducts(BaseOrSelectedVariant, option_html), select2, select2.querySelector(`option[data-id="${BaseOrSelectedVariant.id.toString()}"]`), select2.querySelector(`option[data-id="54525805166940"]`));
        let isMultiple = option_html ? option_html.indexOf(window.pieces_text) > -1 : multipleProducts(BaseOrSelectedVariant, option_html ? option_html.trim() : null);
        if (select2 != null) {
          if (select2.dataset.select == "extra-bedmate" || select2.dataset.select == "extra-bigdot") {
            isMultiple = false;
          }
        }
        let originalPrice = isMultiple ? pricing(BaseOrSelectedVariant.price * 2) : pricing(BaseOrSelectedVariant.price);
        let discountedPrice = pricing(
          renderDiscount(
            BaseOrSelectedVariant.price,
            Number(discountextra),
            isMultiple
          )
        );
        pricingElement.innerHTML = `${discountedPrice} <span class="percentage">(${discountextra}%)</span><s>${originalPrice}</s> `;
      }
      select2.innerHTML = options.join("");
      let correctLayer = layer;
      if (product.variants[0].product_title.includes("Kussensloop")) {
        correctLayer = 5;
      } else {
        correctLayer = layer;
      }
      if (product.variants[0].product_title.includes("bigDOT")) {
        correctLayer = 7;
      } else {
        correctLayer = layer;
      }
      if (select2.dataset.select == "extra-bedmate" || select2.dataset.select == "extra-bigdot") {
        if (BaseOrSelectedVariant) {
          let option_title = BaseOrSelectedVariant.product_title + " - " + BaseOrSelectedVariant.option2;
          let matchingOption = Array.from(select2.options).find((option) => {
            return option.textContent.trim() === option_title.trim();
          });
          if (matchingOption) {
            matchingOption.selected = true;
          }
        }
      }
      if (bedMateSize !== null) {
        let currentConfig = sessionStorage.getItem("configuratorConfig") ? JSON.parse(sessionStorage.getItem("configuratorConfig")) : [];
        if (currentConfig["4"]) {
          currentConfig["4"][checkbox.dataset.extraItem] = BaseOrSelectedVariant;
        } else {
          currentConfig["4"] = {};
          currentConfig["4"][checkbox.dataset.extraItem] = BaseOrSelectedVariant;
        }
        sessionStorage.setItem("configuratorConfig", JSON.stringify(currentConfig));
      } else {
        let firstAvailableVariant = variants.find((variant) => {
          return variant.available;
        });
        console.log("firstAvailableVariant ", firstAvailableVariant, variants[0]);
        handlePillowColor(product, firstAvailableVariant ? firstAvailableVariant.option2 : variants[0].option2, checkbox.dataset.selector, checkbox.dataset.extraItem, select2);
        if (firstAvailableVariant == void 0) {
          select2.querySelector("option:first-of-type").selected = true;
          select2.dispatchEvent(new Event("change"));
        }
      }
      if (select2.value == "" || select2.value == null) {
        select2.querySelector("option:first-of-type").selected = true;
      }
      let isLast = select2.closest("configurator-extra") === document.querySelectorAll("configurator-extra")[document.querySelectorAll("configurator-extra").length - 1];
      if (select2.querySelector(`option[value="${select2.value}"]`).hasAttribute("disabled") == true) {
        select2.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.add("disabled");
        if (isLast) {
          select2.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.add("for_the_last");
        }
      } else {
        select2.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.remove("disabled");
        if (isLast) {
          select2.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.remove("for_the_last");
        }
      }
      window.updateSummaryPopup();
      handleProductImage(product.variants[0].image, correctLayer, product.variants[0].image_url);
      select2.addEventListener("change", () => {
        handlePillowColor(product, select2.value, checkbox.dataset.selector, checkbox.dataset.extraItem, select2);
        setUrlParams(select2, BaseOrSelectedVariant, product);
        if (select2.value.includes("50")) {
          sessionStorage.setItem("bedMateSize", select2.value);
        }
        let isLast2 = select2.closest("configurator-extra") === document.querySelectorAll("configurator-extra")[document.querySelectorAll("configurator-extra").length - 1];
        if (select2.querySelector(`option[value="${select2.value}"]`).hasAttribute("disabled") == true) {
          select2.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.add("disabled");
          if (isLast2) {
            select2.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.add("for_the_last");
          }
        } else {
          select2.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.remove("disabled");
          if (isLast2) {
            select2.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.remove("for_the_last");
          }
        }
        window.updateSummaryPopup();
      });
    };
    const handleActiveColor = (colorDot, colorDots) => {
      colorDots.forEach((dot) => {
        dot.querySelector(".color").classList.remove("current-selected");
      });
      colorDot.querySelector(".color").classList.add("current-selected");
    };
    const handleColorIndicator = (button) => {
      let colorIndicator = this.querySelector(button.dataset.colortarget);
      let color = button.dataset.color;
      if (color && colorIndicator) {
        colorIndicator.innerHTML = color;
      }
    };
    const handleFallbackImage = () => {
      let config = JSON.parse(sessionStorage.getItem("configuratorConfig"));
      if (config && config[1] === null) {
        let fallbackImage = document.querySelector(".configurator-media__inner").dataset.fallbackImage;
        let baseImageLayer = document.querySelector(".image-layer-1");
        baseImageLayer.removeAttribute("srcset");
        baseImageLayer.src = fallbackImage;
      }
    };
    const handleColorDots = (checkbox, variantSelector) => {
      let colorDots = this.querySelectorAll(".colors-grid__item");
      const handleFallbackColor = () => {
        colorDots.forEach((button) => {
          if (button.querySelector(".color").classList.contains("current-selected")) {
            handleColorIndicator(button);
          }
        });
      };
      if (colorDots) {
        colorDots.forEach((colorDot) => {
          colorDot.addEventListener("click", () => {
            handleActiveColor(colorDot, colorDots);
            let productData2 = this.querySelector(`.js-product-${checkbox.dataset.selector}`).innerHTML;
            let product = JSON.parse(productData2).find((p) => {
              return p.id === Number(colorDot.dataset.id);
            });
            if (product) {
              handleProductSelect(product, variantSelector, checkbox, checkbox.dataset.selector);
            }
            handleColorIndicator(colorDot);
            handleFallbackImage();
            let bedMateSize = sessionStorage.getItem("bedMateSize") ? sessionStorage.getItem("bedMateSize") : null;
            if (bedMateSize !== null) {
              variantSelector.querySelectorAll("option:not([disabled])")[0];
              let prefOption = variantSelector.querySelector(`option[value="${bedMateSize}"]`);
              if (prefOption !== null) {
                variantSelector.value = bedMateSize;
                handleProductSelect(product, variantSelector, checkbox, checkbox.dataset.selector);
              }
            }
            let currentConfig = sessionStorage.getItem("configuratorConfig") ? JSON.parse(sessionStorage.getItem("configuratorConfig")) : [];
            if (currentConfig && currentConfig[4]) {
              console.log("ssssss");
              let extraProducts = currentConfig[4];
              let totalPrice = 0;
              Object.values(extraProducts).forEach((item) => {
                if (item && item.product_id) {
                  let price = item.price;
                  totalPrice += price;
                  console.log("totalPrice ", totalPrice);
                }
              });
              let discounted = totalPrice - totalPrice * 0.2;
              let formattedDiscounted = pricing(discounted);
              let formattedOriginal = pricing(totalPrice);
              document.querySelectorAll(".js_price_extra")[document.querySelectorAll(".js_price_extra").length - 1].innerHTML = formattedDiscounted + "(20% off) <s>" + formattedOriginal + "</s>";
            }
            let isLast = variantSelector.closest("configurator-extra") === document.querySelectorAll("configurator-extra")[document.querySelectorAll("configurator-extra").length - 1];
            if (variantSelector.querySelector(`option[value="${variantSelector.value}"]`).hasAttribute("disabled") == true) {
              variantSelector.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.add("disabled");
              if (isLast) {
                variantSelector.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.add("for_the_last");
              }
            } else {
              variantSelector.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.remove("disabled");
              if (isLast) {
                variantSelector.closest("configurator-extra").querySelector("button.button-holder__button.button").classList.remove("for_the_last");
              }
            }
          });
          colorDot.addEventListener("mouseenter", () => {
            handleColorIndicator(colorDot);
          });
          colorDot.addEventListener("mouseleave", () => {
            handleFallbackColor();
          });
        });
      }
    };
    if (checkboxes) {
      checkboxes.forEach((checkbox) => {
        let variantSelector = this.querySelector(`.variant-selector__select--${checkbox.dataset.selector}`);
        handleColorDots(checkbox, variantSelector);
        checkbox.addEventListener("change", (e) => {
          let productContainer = this.querySelector(`.product-${checkbox.dataset.selector}`);
          if (checkbox.checked && productContainer) {
            productContainer.classList.remove("hidden");
            checkmark.classList.toggle("icon-checkmark--active");
          } else {
            let currentConfig2 = sessionStorage.getItem("configuratorConfig") ? JSON.parse(sessionStorage.getItem("configuratorConfig")) : [];
            checkmark.classList.toggle("icon-checkmark--active");
            if (currentConfig2["4"]) {
              currentConfig2["4"][checkbox.dataset.extraItem] = null;
              sessionStorage.setItem("configuratorConfig", JSON.stringify(currentConfig2));
              handleRemoveProductImage(checkbox.dataset.extralayer);
            }
            productContainer.classList.add("hidden");
          }
          console.log(Number(checkbox.dataset.extraItem), checkbox.dataset.selector, " Number(checkbox.dataset.extraItem)");
          if (Number(checkbox.dataset.extraItem) !== 1 && Number(checkbox.dataset.extraItem) !== 4) {
            handleColorDots(checkbox, variantSelector);
          } else {
            if (variantSelector && checkbox.checked) {
              console.log("ssss sss s s ");
              let firstOption = variantSelector.querySelectorAll("option:not([disabled])")[0];
              let prefSize = sessionStorage.getItem("studiosuite_pref_size") ? sessionStorage.getItem("studiosuite_pref_size") : null;
              let prefOption = variantSelector.querySelector(`option[data-size=${prefSize}]`);
              if (prefOption !== null) prefOption.selected = true;
              handleVariantChange(
                prefOption !== null ? prefOption === null || prefOption === void 0 ? void 0 : prefOption.value : firstOption === null || firstOption === void 0 ? void 0 : firstOption.value,
                checkbox.dataset.selector,
                checkbox.dataset.extraItem,
                false,
                variantSelector
              );
              let bedMateSize = sessionStorage.getItem("bedMateSize") ? sessionStorage.getItem("bedMateSize") : null;
              if (bedMateSize !== null) {
                let bedMateOption = variantSelector.querySelector(`option[value="${bedMateSize}"]`);
                if (bedMateOption) {
                  bedMateOption.selected = true;
                  handleVariantChange(bedMateOption.value, checkbox.dataset.selector, checkbox.dataset.extraItem, false, variantSelector);
                }
              }
              variantSelector.addEventListener("change", (e2) => {
                sessionStorage.setItem("bedMateSize", e2.target.value.split(" - ")[1]);
                handleVariantChange(variantSelector.value, checkbox.dataset.selector, checkbox.dataset.extraItem, false, variantSelector);
              });
              handleFallbackImage();
            } else if (checkbox.checked) {
              let _productData3 = this.querySelector(`.js-product-${checkbox.dataset.selector}`).innerHTML;
              let product = JSON.parse(_productData3);
              handleVariantChange(product.variants[0].option2, checkbox.dataset.selector, checkbox.dataset.extraItem, false, variantSelector);
              handleFallbackImage();
            }
          }
          let currentConfig = sessionStorage.getItem("configuratorConfig") ? JSON.parse(sessionStorage.getItem("configuratorConfig")) : [];
          if (currentConfig && currentConfig[4]) {
            console.log("ssssss");
            let extraProducts = currentConfig[4];
            let totalPrice = 0;
            Object.values(extraProducts).forEach((item) => {
              if (item && item.product_id) {
                let price = item.price;
                totalPrice += price;
                console.log("totalPrice ", totalPrice);
              }
            });
            let discounted = totalPrice - totalPrice * 0.2;
            let formattedDiscounted = pricing(discounted);
            let formattedOriginal = pricing(totalPrice);
            document.querySelectorAll(".js_price_extra")[document.querySelectorAll(".js_price_extra").length - 1].innerHTML = formattedDiscounted + "(20% off) <s>" + formattedOriginal + "</s>";
          }
        });
      });
      nextButton.addEventListener("click", () => {
        handleNextLayer();
        if ($(window).width() <= 768) {
          console.log("mobile");
          window.scrollTo({
            top: 132,
            left: 0,
            behavior: "smooth"
          });
        } else {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
          });
        }
      });
      previousButton.addEventListener("click", (e) => {
        let nextLayer2 = previousButton.dataset.next;
        let currentLayer2 = previousButton.dataset.current;
        let nextStep2 = document.querySelector(`.layer-${nextLayer2}`);
        let currentLabel = document.querySelector(`.layer-label-${currentLayer2}`);
        let currentlabelwidth = document.querySelector(`.layer-label-${currentLayer2}`).offsetWidth;
        let checkmark2 = document.querySelector(`.layer-label-${currentLayer2} .icon-checkmark`);
        let overview = document.querySelector("configurator-overview");
        let newScrollPosition = currentlabelwidth + buttonRow.scrollRight;
        if (Number(nextLayer2) == 4) {
          overview.classList.remove("hidden");
          let selectedItems = JSON.parse(sessionStorage.getItem("configuratorConfig"));
          let filteredItems = selectedItems ? selectedItems.filter((selectedItem) => selectedItem !== null) : [];
          let selected_items = [];
          filteredItems.forEach((val) => {
            if (Object.entries(val)[0][1].extraProduct === true) {
              for (let i in val) {
                let v = val[i];
                if (v && v.product_title && v.option1 && v.option2) {
                  selected_items.push({
                    title: v.product_title,
                    select_colour: v.full_option1,
                    select_size: v.full_option2
                  });
                }
              }
            } else {
              selected_items.push({
                title: val.product_title,
                select_colour: val.full_option1,
                select_size: val.full_option2
              });
            }
          });
          window.dataLayer = window.dataLayer || [];
          let alreadyPushed = window.dataLayer.some(
            (entry) => {
              var _a;
              return entry.event === "configuratorItemsSelected" && JSON.stringify((_a = entry.ecommerce) == null ? void 0 : _a.items) === JSON.stringify(selected_items);
            }
          );
          if (!alreadyPushed) {
            window.dataLayer.push({
              event: "configuratorItemsSelected",
              ecommerce: {
                items: selected_items
              }
            });
          }
        }
        if (nextStep2) {
          nextStep2.checked = true;
          nextStep2.classList.remove("active");
          nextStep2.parentElement.classList.remove("button-row__button--no-events");
          checkmark2.classList.remove("icon-checkmark--active");
          currentLabel.classList.remove("handled");
          buttonRow.scroll({
            top: 0,
            left: newScrollPosition,
            behavior: "smooth"
          });
        }
      });
      if (colorGrids) {
        colorGrids.forEach((colorGrid) => {
          handleColorScroll(colorGrid);
        });
      }
      const handleActiveURLParams = () => {
        let url = new URL(window.location.href);
        url.searchParams.forEach((value, key) => {
          if (param === key) {
            let productId = value.split("-")[0];
            value.split("-")[1];
            let product = productData.find((p) => {
              return p.id === Number(productId);
            });
            console.log(product);
            handleProductSelect(product, select, localCheckbox, localCheckbox.dataset.selector);
            localCheckbox.checked = true;
            let container = localCheckbox.closest(".configurator-variant");
            let colorDotContainer = container === null || container === void 0 ? void 0 : container.querySelector(".product-option");
            colorDotContainer === null || colorDotContainer === void 0 ? void 0 : colorDotContainer.classList.remove("hidden");
            let activeProduct = this.querySelector(`.colors-grid__item[data-id="${productId}"]`);
            let color = activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.querySelector(".color");
            color === null || color === void 0 ? void 0 : color.classList.add("current-selected");
          }
        });
      };
      setTimeout(() => {
        handleActiveURLParams();
      }, 100);
    }
  }
}
if (customElements.get("configurator-extra") === void 0) {
  customElements.define("configurator-extra", ConfiguratorExtra);
}
